import { render, staticRenderFns } from "./VariomesFullText.vue?vue&type=template&id=6b3a65a1&scoped=true&"
import script from "./VariomesFullText.vue?vue&type=script&lang=js&"
export * from "./VariomesFullText.vue?vue&type=script&lang=js&"
import style0 from "./VariomesFullText.vue?vue&type=style&index=0&id=6b3a65a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3a65a1",
  null
  
)

export default component.exports